<template>
    <section>
        <div class="tools d-flex justify-content-end">
            <h5>Drag list item</h5>
        </div>
        <draggable class="list-group" v-model="items" @start="dragging=true">
            <transition-group>
                <div class="cursor--move list-group-item" v-for="item in items" :key="item.id">
                    <div class="d-flex justify-content-between ">
                        <div>{{item.ticket_data.lang.en_GB.title}}</div>
                    </div>
                </div>
            </transition-group>
        </draggable>
        <transition name="fade">
            <div v-if="dragging" @click="submitUpdate" class="btn btn-primary">Save order</div>
        </transition>

    </section>
</template>

<script>
	import draggable from 'vuedraggable'

	export default {
		props: ['params'],
		components: {
			draggable
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			console.log('this.params.collection.list', this.params.collection.list);
			this.read()
		},
		data() {
			return {
				dragging: false,
				items: []
			}
		},
		methods: {
			log(item) {
				console.log('item', item);
			},
			read() {
				let _this = this;
				axios.get(_this.params.routes.read)
					.then(function (response) {
						if (response.status !== 200) {
							console.error('response', response);
						}
						else {
							_this.items = response.data[_this.params.collection.name];
							console.log('_this.items',_this.items);
						}
					});
			},
			submitUpdate() {
				// console.log('this.items', this.items);
				let orderList = [], _this = this;
				//
				for (let i = 0, len = this.items.length; i < len; i++) {
					//
					// 	// this.items[i].lft = i + 1;
					orderList.push({
						id: this.items[i].id,
						lft: i + 1
					});
				}
				//
				axios.post(_this.params.routes.update, {
					order: orderList
				})
					.then(function (response) {
						if (response.status !== 200) {
							console.error('response', response);
						}
						else {
							console.log('response', response);
						}
						_this.dragging = false;
					});

			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/lists/RearrangeOrderList.vue?c92307da